import { Box, Typography, Avatar } from "@mui/material";
import ModalBasicLayout from "./ModalBasicLayout";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  MODAL_WELCOME_SUBTITLE,
  MODAL_WELCOME_TITLE,
} from "../../i18n/keysTranslations";
import SuccessConfetti from "../Common/SuccessConfetti";
import { useDispatchApp } from "../../lib/redux";
import { getNameBusinessTheme } from "../../actions/getters";

const ModalWelcome = ({ modalOpen, onCloseModal }) => {
  const { t } = useTranslation();
  const [fireConfetti, setFireConfetti] = useState(false);

  const dispatch = useDispatchApp();
  const NAME_BUSINESS = dispatch(getNameBusinessTheme());

  useEffect(() => {
    if (modalOpen) {
      const timer = setTimeout(() => {
        setFireConfetti(true);
      }, 200);

      return () => clearTimeout(timer);
    }
    setFireConfetti(false);
  }, [modalOpen]);

  return (
    <>
      <ModalBasicLayout
        modalOpen={modalOpen}
        onCloseModal={onCloseModal}
        title=""
        maxWidth="sm"
        fullWidth
        showCloseButton={true}
        sxContent={{
          textAlign: "center",
          py: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 3,
          }}
        >
          <Avatar
            sx={{
              width: 80,
              height: 80,
              bgcolor: "background.paper",
              mb: 2,
            }}
          >
            <CheckCircleIcon sx={{ fontSize: 80, color: "white", mt: 1 }} />
          </Avatar>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "text.primary",
              }}
            >
              {t(MODAL_WELCOME_TITLE, { NAME_BUSINESS })}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: "text.secondary",
              }}
            >
              {t(MODAL_WELCOME_SUBTITLE)}
            </Typography>
          </Box>
        </Box>
      </ModalBasicLayout>

      {/* Componente de confeti */}
      <SuccessConfetti fire={fireConfetti} />
    </>
  );
};

export default ModalWelcome;
